import script from "./SelectAsyncWithImage.vue?vue&type=script&lang=ts&setup=true"
export * from "./SelectAsyncWithImage.vue?vue&type=script&lang=ts&setup=true"

import "./SelectAsyncWithImage.vue?vue&type=style&index=0&id=d667433e&lang=scss&scoped=true"

import exportComponent from "/builds/harapan-jaya/hjp/hjp-cms/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d667433e"]])

export default __exports__